<script setup lang="ts">
import { RrDrawer, type DrawerProps } from '@xjlv2/ui'

const props = withDefaults(defineProps<DrawerProps>(), {
  open: false, width: 520, height: 360,
  closable: undefined, mask: undefined, maskClosable: undefined, keyboard: undefined,
  confirmLoading: undefined, showFooter: undefined, showCancel: undefined, showOk: undefined,
  destroyOnClose: undefined, forceRender: undefined, footer: undefined, getContainer: undefined
})
const emit = defineEmits<{ 'update:open': [open: boolean]; close: [event?: Event]; ok: [event: MouseEvent]; afterOpenChange: [open: boolean] }>()
</script>

<template>
  <RrDrawer v-bind="props" @update:open="emit('update:open', $event)" @close="emit('close', $event)" @ok="emit('ok', $event)" @after-open-change="emit('afterOpenChange', $event)">
    <template v-for="(_, name) in $slots" #[name]="slotProps"><slot :name="name" v-bind="slotProps ?? {}" /></template>
  </RrDrawer>
</template>
